import React, { useState } from "react";
import { toast } from "react-toastify";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import { i18n } from "../../translate/i18n";
import ButtonWithSpinner from "../ButtonWithSpinner";
import TaskUserAutocomplete from "../TaskUserAutocomplete";
import { buildTransferTaskPayload } from "../../pages/Tasks/taskUtils";

// Diálogo de transferência — o responsável atual nunca aparece nas opções
// (excludeIds), então o ERR_TASK_TRANSFER_SAME_USER do backend não deveria
// ocorrer no fluxo normal, mas o toastError do onConfirm (no orquestrador)
// já trata esse código com uma mensagem específica, como defesa em
// profundidade.
const TaskTransferDialog = ({ open, onClose, onConfirm, currentAssignedUserId }) => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [saving, setSaving] = useState(false);

  const handleClose = () => {
    if (saving) return;
    onClose();
  };

  const handleConfirm = async () => {
    if (!selectedUser) return;

    setSaving(true);
    const payload = buildTransferTaskPayload({ newAssignedUserId: selectedUser.id });
    const success = await onConfirm(payload);
    setSaving(false);

    if (success) {
      toast.success(i18n.t("tasks.details.actions.transferSuccess"));
      setSelectedUser(null);
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="task-transfer-dialog-title"
      disableBackdropClick={saving}
      disableEscapeKeyDown={saving}
    >
      <DialogTitle id="task-transfer-dialog-title">
        {i18n.t("tasks.details.actions.transferTitle")}
      </DialogTitle>
      <DialogContent dividers>
        <TaskUserAutocomplete
          label={i18n.t("tasks.details.actions.newAssignedUser")}
          required
          value={selectedUser}
          onChange={setSelectedUser}
          excludeIds={currentAssignedUserId ? [currentAssignedUserId] : []}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={saving} color="secondary" variant="outlined">
          {i18n.t("tasks.details.actions.cancelButton")}
        </Button>
        <ButtonWithSpinner
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          loading={saving}
          // ButtonWithSpinner espalha `disabled` recebido por cima do seu
          // próprio `disabled={loading}` interno — por isso a condição de
          // loading precisa ser combinada aqui, nunca só `!selectedUser`,
          // senão um clique duplo escaparia do bloqueio durante o envio.
          disabled={saving || !selectedUser}
        >
          {i18n.t("tasks.details.actions.transferConfirmButton")}
        </ButtonWithSpinner>
      </DialogActions>
    </Dialog>
  );
};

export default TaskTransferDialog;
